
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="Account">
    <b-tabs @activate-tab="changeTab($event)">
      <b-tab
        v-for="(tab, index) in tabs"
        :title="$t(tab.name)"
        :key="index"
        button-id="index"
        :active="$route.name === tab.route"
        lazy
      >
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: "Account",
  data() {
    return {
      tabs: [
        { name: "profile", route: "Profile" },
        // {name: 'security', route: 'Security'},
        // { name: "notifications", route: "AccountNotifications" },
        // { name: "email", route: "AccountEmail" }
        // {name: 'users', route: 'Users'},
        // {name: 'roles', route: 'Roles'},
      ],
    };
  },
  methods: {
    changeTab(index) {
      this.$router.push({ name: this.tabs[index].route });
    },
  },
};
</script>

<style lang='scss'>
.view-area {
  position: relative;
  min-height: 560px;
  height: calc(100vh - 480px);
  padding-right: 1rem;
  margin-right: -1rem;
  overflow-y: auto;
}
.view-area-table {
  position: relative;
  min-height: 530px;
  height: calc(100vh - 530px);
}
</style>
